module.exports = __webpack_public_path__ + "184b328192ac4fd8351bcbdfd102c8f3.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/mfizz/mfizz.woff2
 ** module id = ./src/styles/fonts/mfizz/mfizz.woff2
 ** module chunks = 0
 **/